import { Box, Skeleton } from "@mui/material"
import type React from "react"

const OfferSkeleton: React.FC = () => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    mt={10}
    p={4}
    width={300}
  >
    <Box maxWidth="md" width="100%" sx={{ "& > *": { mb: 3 } }}>
      {/* Header skeleton */}
      <Box display="flex" alignItems="center" gap={2}>
        <Skeleton variant="circular" width={64} height={64} />
        <Box flex={1}>
          <Skeleton variant="text" width="75%" height={24} />
          <Skeleton variant="text" width="50%" height={20} />
        </Box>
      </Box>

      {/* Content skeleton */}
      <Box>
        <Skeleton variant="text" height={32} />
        <Skeleton variant="text" width="85%" height={20} />
        <Skeleton variant="text" width="70%" height={20} />
        <Skeleton variant="text" width="80%" height={20} />
      </Box>

      {/* Details skeleton */}
      <Box display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
        <Box>
          <Skeleton variant="text" width="30%" height={16} />
          <Skeleton variant="text" height={24} />
        </Box>
        <Box>
          <Skeleton variant="text" width="30%" height={16} />
          <Skeleton variant="text" height={24} />
        </Box>
      </Box>

      {/* Price skeleton */}
      <Box textAlign="center">
        <Skeleton variant="text" width="30%" height={40} sx={{ mx: "auto" }} />
      </Box>
    </Box>
  </Box>
)

export default OfferSkeleton
